import { FC } from "react";
import "@rmwc/tooltip/styles";
import { Tooltip as MdTooltip } from "@rmwc/tooltip";
import { TooltipProps } from "./commons/tooltip-props";

const Tooltip: FC<TooltipProps> = (props) => {
  const { title, className, open, children, enterDelay, activateOn, showArrow, leaveDelay } = props;

  return (
    <MdTooltip
      content={title}
      align={"bottom"}
      enterDelay={enterDelay}
      className={className}
      showArrow={showArrow}
      open={open}
      leaveDelay={leaveDelay}
      activateOn={activateOn}
    >
      {children}
    </MdTooltip>
  );
};

export default Tooltip;
